import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import "./index.scss";
import Table from "./table";
import { useSlideLefOpening } from "../betbar/dropdown";
import { useAppSelector } from "../../store/hook";

const History = () => {

  const animate = useSlideLefOpening('flex', true);
 



  return (
    <div className="history">
   
      <Table {...{ ...animate }} />
      {/* {outIdx > -1 ? <Out {...{ ...animateOut, dataHistory: historyData[outIdx], setOutIdx }} /> : <></>} */}

    </div>
  );
};

export default History;
